import usePluginHandler from '../../../hooks/usePluginHandler';
import { isCalledByParent } from '../../../models/caller';
import { PluginMessageTypes } from '../../../models/constants';
import MessagesPlugin from '../../../models/messages';

const messageToNoRedirect = [
  PluginMessageTypes.LOADED,
  PluginMessageTypes.CHANGE_HASH,
  PluginMessageTypes.CHANGE_HASH2,
  PluginMessageTypes.CALL_FORWARD,
  PluginMessageTypes.DIALOG_SIZE,
  PluginMessageTypes.DIALOG_OK,
  PluginMessageTypes.DIALOG_CANCEL,
];

const handleMessages = (message) => {
  if (isCalledByParent() && !messageToNoRedirect.includes(message.type)) {
    MessagesPlugin.forwardMessageToParent(message);
  }
};

export default function useForwardMessageToParent() {
  usePluginHandler(handleMessages);
}
